export default {
    data: () => ({
        translations: {
            registerUser: {
                el: "Πρόσθηκη Χρήστη",
                en: "Register User",
                it: "Registra utente"
            },
            user: {
                el: "Χρήστης",
                en: "User",
                it: "Utente"
            },
            user2: {
                el: "Χρήστη",
                en: "User",
                it: "Utente"
            },
            userRole: {
                el: "Ρόλος",
                en: "Role",
                it: "Ruolo"
            },
            date: {
                el: "Ημερομηνία",
                en: "Date",
                it: "Data"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            homepage: {
                el: "Αρχική Σελίδα",
                en: "Homepage",
                it: "Pagina iniziale"
            },
            transactions: {
                el: "Συναλλαγές",
                en: "Transactions",
                it: "Transazioni"
            },
            redemption: {
                el: "Τιμολόγηση",
                en: "Redemptions",
                it: "Fatturazione"
            },
            history: {
                el: "Ιστορικό",
                en: "History",
                it: "Storia"
            },
            contests: {
                el: "Διαγωνισμοί",
                en: "Contests",
                it: "Concorso"
            },
            company: {
                el: "Εταιρεία",
                en: "Company",
                it: "Azienda"
            },
            
            customers: {
                el: "customers",
                en: "customers",
                it: "customers"
            },
            general_settings: {
                el: "general_settings",
                en: "general_settings",
                it: "general_settings"
            },
            products: {
                el: "Προϊόντα",
                en: "Products",
                it: "Prodotti"
            },
            coupons: {
                el: "Κουπόνια",
                en: "Coupons",
                it: "Buoni"
            },
            settings: {
                el: "Ρυθμίσεις",
                en: "Settings",
                it: "Impostazioni"
            },
            company_products: {
                el: "Προϊόντα εταιρείας",
                en: "Company products",
                it: "Prodotti aziendali"
            },
            rights: {
                el: "Δικαιώματα",
                en: "Rights",
                it: "Diritti"
            },
            authorization: {
                el: "Εξουσιοδότηση",
                en: "Authorization",
                it: "Autorizzazione"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancella"
            },
            newUser: {
                el: "Πρόσθηκη Χρήστη Πλατφόρμας",
                en: "Add Panel User",
                it: "Aggiungi Utente Pannello"
            },
            updateUser: {
                el: "",
                en: "Update User",
                it: ""
            },
            mobile: {
                el: "Κινητό",
                en: "Mobile",
                it: "Mobile"
            },
            password: {
                el: "Κωδικός",
                en: "Password",
                it: "Codice"
            },
            permissions: {
                el: "Χρήστες",
                en: "Users",
                it: "Utenti"
            },
            updateAll: {
                el: "Ανανέωση όλων",
                en: "Update All",
                it: "Aggiorna tutto"
            },
            upgrade: {
                el: "Αναβάθμιση",
                en: "Upgrade",
                it: "Aggiornamento"
            },
            downgrade: {
                el: "Υποβάθμιση",
                en: "Downgrade",
                it: "Declassamento"
            },
            confirmationMessageSure: {
                el: "Σίγουρα θέλεις να",
                en: "Are you sure you want to",
                it: "Siete sicuri di voler"
            },
            deleteConfirmationMessage: {
                el: " <b>διαγράψεις</b> τον χρήστη ",
                en: " <b>delete</b> user ",
                it: " <b>eliminare</b> l'utente "
            },
            upgradeConfirmationMessage: {
                el: " <b>αναβαθμίσεις</b> τον χρήστη ",
                en: " <b>upgrade</b> the user ",
                it: " <b>aggiornare</b> l'utente "
            },
            downgradeConfirmationMessage: {
                el: " <b>υποβαθμίσεις</b> τον χρήστη ",
                en: " <b>downgrade</b> the user ",
                it: " <b>declassare</b> l'utente "
            },
            downgradeTo: {
                el: "σε <b>moderator</b>",
                en: "to <b>moderator</b>",
                it: "a <b>moderatore</b>"
            },
            upgradeTo: {
                el: " σε <b>manager</b>",
                en: " to <b>manager</b>",
                it: " a <b>manager</b>"
            },
            questionmark: {
                el: ";",
                en: "?",
                it: "?"
            },
        }
    })
};
